import { c as _c } from "react/compiler-runtime";
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import useUser from 'shared/hooks/use-user';
import { SharingStatusEnum } from 'modules/share/enum/sharing-status-enum';
import { SharingStatusInterface } from '../types/sharing-status-interface';
import { getSharingStatusPath } from '../api';
export const useSharingStatusPolling = t0 => {
  const $ = _c(8);
  const {
    sharingId
  } = t0;
  const {
    user
  } = useUser();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    fetcher
  } = useFetch(t1);
  let t2;
  if ($[1] !== sharingId || $[2] !== user) {
    t2 = () => {
      if (!user) {
        return;
      }
      if (!sharingId) {
        return;
      }
      return getSharingStatusPath(sharingId);
    };
    $[1] = sharingId;
    $[2] = user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      refreshInterval(latestData) {
        if (latestData?.status === SharingStatusEnum.Running) {
          return 1500;
        }
        return 0;
      },
      errorRetryCount: 3
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const {
    data: sharingStatus,
    mutate
  } = useControlledSwr(t2, fetcher, t3, !!sharingId);
  let t4;
  if ($[5] !== mutate || $[6] !== sharingStatus) {
    t4 = {
      sharingStatus,
      mutate
    };
    $[5] = mutate;
    $[6] = sharingStatus;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};